<template>
    <FlashMessage @close="close" :message="message" :error="error" />
</template>

<script>
import FlashMessage from '@/Components/Notifications/FlashNotifications/FlashMessage.vue'
export default {
    components: {
        FlashMessage,
    },

    computed: {
        error() {
            return this.$page.props.flash?.error
        },

        message() {
            return this.$page.props.flash?.message
        },
    },

    methods: {
        close() {
            this.$page.props.flash.message = null
            this.$page.props.flash.error = null
        },
    },
}
</script>
